<div class="container-fluid">
    @if (loading) {
        <spinner></spinner>
    } @else if (loadError) {
        <div class="organisation-detail-message alert alert-warning" role="alert" tabindex="-1" #message
             data-testid="organisation-detail-error">
            <h1 class="h4">{{ loadError === 'denied' ? 'Access denied' : (loadError === 'not-found' ? 'Organisation not found' : 'Organisation unavailable') }}</h1>
            <p class="mb-2">{{ errorMessage }}</p>
            <a [routerLink]="listRoute" data-testid="organisation-back-to-list">Back to organisations</a>
        </div>
    } @else if (organisation) {
        <h1 class="h4 pb-3">
            {{ organisation.name || organisation.code }}
            @if (statusLabel) {
                <span class="badge ms-2 organisation-status-badge" [class.badge-deleted]="statusLabel === 'Deleted'" [class.badge-deactivated]="statusLabel === 'Deactivated'" data-testid="organisation-status-badge">{{ statusLabel }}</span>
            }
        </h1>

        <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs" aria-label="Organisation sections">
            <li ngbNavItem="general">
                <button ngbNavLink type="button" data-testid="organisation-tab-general">General details</button>
                <ng-template ngbNavContent>
                    <div class="organisation-detail-card">
                        <cdss-organisation-form idPrefix="organisation-detail"
                                                [organisation]="organisation"
                                                [readOnly]="!isEditable"
                                                [codeReadOnly]="!canEditCode"
                                                [codePrefix]="codePrefix"
                                                [saving]="saving"
                                                [codeError]="codeError"
                                                (save)="onSave($event)">
                            @if (canDelete) {
                                <cdss-organisation-delete-panel [organisation]="organisation"
                                                                [linkedContracts]="linkedContracts"
                                                                [linkedServices]="linkedServices"
                                                                (deleted)="onDeleted()"></cdss-organisation-delete-panel>
                            }
                        </cdss-organisation-form>
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem="contracts">
                <button ngbNavLink type="button" data-testid="organisation-tab-contracts">Contracts</button>
                <ng-template ngbNavContent>
                    <cdss-organisation-contracts-tab [organisation]="organisation"
                                                     (changed)="reloadLinks()"></cdss-organisation-contracts-tab>
                </ng-template>
            </li>
            <li ngbNavItem="care-programmes">
                <button ngbNavLink type="button" data-testid="organisation-tab-care-programmes">Care programmes</button>
                <ng-template ngbNavContent>
                    <cdss-organisation-care-programs-tab [organisation]="organisation"
                                                         (changed)="reloadLinks()"></cdss-organisation-care-programs-tab>
                </ng-template>
            </li>
            <li ngbNavItem="services">
                <button ngbNavLink type="button" data-testid="organisation-tab-services">Services</button>
                <ng-template ngbNavContent>
                    <cdss-organisation-services-tab [organisation]="organisation"
                                                    (changed)="reloadLinks()"></cdss-organisation-services-tab>
                </ng-template>
            </li>
            @if (canManageAdmins) {
                <li ngbNavItem="admins">
                    <button ngbNavLink type="button" data-testid="organisation-tab-admins">Organisation admins</button>
                    <ng-template ngbNavContent>
                        <cdss-organisation-admins-tab [organisation]="organisation"
                                                      (changed)="reloadLinks()"></cdss-organisation-admins-tab>
                    </ng-template>
                </li>
            }
            @if (canViewHistory) {
                <li ngbNavItem="history">
                    <button ngbNavLink type="button" data-testid="organisation-tab-history">History</button>
                    <ng-template ngbNavContent>
                        <cdss-organisation-history-tab [organisation]="organisation"
                                                       [linkedServices]="linkedServices"
                                                       (changed)="onStateChanged()"></cdss-organisation-history-tab>
                    </ng-template>
                </li>
            }
        </ul>
        <div class="organisation-detail-panel">
            <div [ngbNavOutlet]="nav"></div>
        </div>
    }
</div>
